import api from '../../plugins/api';

const generateCheck = ({ bankId, chunkId }) => {
  return api.post('/api/documents/check', { bankId, chunkId });
};

export default generateCheck;
